<template>
  <div class="icon-card">
    <div class="icon-card__col__cover__wrap">
      <img class="icon-card__col__cover" v-lazy="icon.imageURL" alt="icon block" />
    </div>
    <div class="mt-8 text-xs md:text-sm text-grey-darkest font-medium">{{ icon.name }}</div>
  </div>
</template>
<script>
export default {
  name: 'iconCard',
  props: ['icon']
}
</script>
<style lang="sass" scoped>
.icon-card
  @apply text-center
  &__col
    @apply relative text-center text-white p-8 flex items-center justify-center w-1/3 cursor-pointer
    &__link
      @apply w-full
    &__cover
      @apply w-full h-full ease
      max-width: 37px
      max-height: 37px
      background:
        position: center
        repeat: no-repeat
        size: cover
      &:hover
        transform: scale(1.1)
      @screen md
        max-width: 48px
        max-height: 48px
      &__wrap
        @apply overflow-hidden w-full
        border-radius: 1.25rem
</style>
